import { useMemo } from 'react';
import { useAuthStore } from '@store/authStore';
import { hasAnyPermission, hasPermission, hasRole } from '@utils/permissions';
import type { PermissionKey } from '@/types';

export function usePermissions() {
  const user = useAuthStore((s) => s.user);

  return useMemo(
    () => ({
      permissions: user?.permissions ?? [],
      roles: user?.roles ?? [],
      can: (perm: PermissionKey | PermissionKey[]) => hasPermission(user?.permissions, perm),
      canAny: (perms: PermissionKey[]) => hasAnyPermission(user?.permissions, perms),
      is: (role: string | string[]) => hasRole(user?.roles as string[] | undefined, role),
    }),
    [user],
  );
}
